module.exports = __webpack_public_path__ + "static/feedback-a18b09656e212fa358119c687733dd3c.png";